import { Component, Input } from '@angular/core';

@Component({
  selector: 'fl-notification-indicator',
  template: `
    <ng-content></ng-content>
    <div *ngIf="active" class="RedDot"></div>
  `,
  styleUrls: ['./notification-indicator.component.scss'],
})
export class NotificationIndicatorComponent {
  @Input() active: boolean;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/notification-indicator/notification-indicator.component.ts